import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_FAC025_Request,
  IAPI_FAC025_Response,
} from "../../../type/apiType";

// 施設情報の変更登録表示
const httpAPI_FAC025 = async (
  param: IAPI_FAC025_Request
): Promise<IAPI_FAC025_Response> => {
  let res = await http.post(ApiUrl.API_FAC025, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_FAC025, httpAPI_APP016 };
